import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack, MenuItem
} from '@mui/material';
import axios from 'axios';

const energyClasses = ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D'];
const btuOptions = [9000, 12000, 18000, 24000];

const BuildingDetailsACsAddAc = ({ buildingId, ac, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        area: '',
        btu: '',
        energy_class: '',
        hours_per_day: '',
        days_per_year: ''
    });

    useEffect(() => {
        if (ac) {
            setFormData({
                area: ac.area || '',
                btu: ac.btu || '',
                energy_class: ac.energy_class || '',
                hours_per_day: ac.hours_per_day || '',
                days_per_year: ac.days_per_year || ''
            });
        }
    }, [ac]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            btu: parseInt(formData.btu),
            hours_per_day: parseInt(formData.hours_per_day),
            days_per_year: parseInt(formData.days_per_year),
            building: parseInt(buildingId)
        };

        const url = ac
            ? `/buildings/${buildingId}/air-conditioners/${ac.id}/`
            : `/buildings/${buildingId}/air-conditioners/`;

        const method = ac ? axios.put : axios.post;

        method(url, payload)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {ac ? 'Edit Air Conditioner' : 'Add Air Conditioner'}
            </Typography>
            <Stack spacing={2}>
                <TextField
                    label="Area"
                    name="area"
                    value={formData.area}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <TextField
                    select
                    label="BTU"
                    name="btu"
                    value={formData.btu}
                    onChange={handleChange}
                    required
                    fullWidth
                >
                    {btuOptions.map(opt => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    select
                    label="Energy Class"
                    name="energy_class"
                    value={formData.energy_class}
                    onChange={handleChange}
                    required
                    fullWidth
                >
                    {energyClasses.map(cls => (
                        <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    label="Hours per Day"
                    name="hours_per_day"
                    type="number"
                    inputProps={{ max: 24, min: 0, step: 1 }}
                    value={formData.hours_per_day}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <TextField
                    label="Days per Year"
                    name="days_per_year"
                    type="number"
                    inputProps={{ max: 365, min: 0 }}
                    value={formData.days_per_year}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="contained" type="submit">
                        {ac ? 'Save' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsACsAddAc;
